// Packages
import { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale-extreme.css";
// Utils
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";
// Styles
import Styles from "./Styles/Cart.module.css";
// Images
import subscriptionImage from "../../../Assets/Icons/subscription.png";
import closeImage from "../../../Assets/Icons/dark-close.png";
import quarterlyImage from "../../../Assets/Icons/quarterly-light.png";
import bookImage from "../../../Assets/Icons/book.png";
import questionImage from "../../../Assets/Icons/question.png";
// Components
import BookCartForCart from "../../Common/Card/BookCartForCart/BookCartForCart";
import QuarterCartForCart from "../../Common/Card/QuarterCartForCart/QuarterCartForCart";
// API
import {
  getArticles,
  getBooks,
  getMyBooks,
  getQuarterlys,
  getSubscriptions,
} from "../../../Services/getData";
import { createAwaitingPayment } from "../../../Services/usersService";
// Context
import { CardContext } from "../../../Context/CardContext";

const Cart = ({ decodedToken, isLoggedIn }) => {
  const history = useHistory();
  const { addItem, deleteItem, items, addSubscription, deleteSubscription } =
    useContext(CardContext);

  const [subscriptionsPrice, setSubscriptionsPrice] = useState(0);

  const [quarterlys, setQuarterlys] = useState([]);
  const [books, setBooks] = useState([]);
  const [textualSubscriptionPrices, setTextualSubscriptionPrices] = useState(
    []
  );
  const [imageSubscriptionPrices, setimageSubscriptionPrices] = useState([]);
  const [userHaveTextualSubscription, setUserHaveTextualSubscription] =
    useState(false);
  const [userHaveImageSubscription, setUserHaveImageSubscription] =
    useState(false);

  // useEffect(() => {
  //   toast.success(
  //     "فرهیخته گرامی، با خرید اشتراک بالای ۳۰۰ هزار تومان، میتوانید از امتیاز پرداخت قسطی بهره مند شوید."
  //   );
  // }, []);

  // useEffect(() => {
  //   const getSubscriptionsApi = async () => {
  //     if (decodedToken) {
  //       const textualSubscription = decodedToken.user.subscriptionStatus.filter(
  //         (i) => i.imageOrTextual === "textual"
  //       );
  //       const imageSubscription = decodedToken.user.subscriptionStatus.filter(
  //         (i) => i.imageOrTextual === "image"
  //       );
  //       try {
  //         if (
  //           textualSubscription.length === 0 &&
  //           imageSubscription.length === 0
  //         ) {
  //           const textualSubscriptions = await getSubscriptions("textual");
  //           setTextualSubscriptionPrices(
  //             textualSubscriptions.data.subscriptions
  //           );
  //           addSubscription(
  //             textualSubscriptions.data.subscriptions[0]._id,
  //             textualSubscriptions.data.subscriptions[0].price,
  //             "textual",
  //             textualSubscriptions.data.subscriptions[0].name
  //           );
  //           const imageSubscriptions = await getSubscriptions("image");
  //           setimageSubscriptionPrices(imageSubscriptions.data.subscriptions);

  //           addSubscription(
  //             imageSubscriptions.data.subscriptions[0]._id,
  //             imageSubscriptions.data.subscriptions[0].price,
  //             "image",
  //             imageSubscriptions.data.subscriptions[0].name
  //           );
  //         } else if (
  //           textualSubscription.length === 0 &&
  //           imageSubscription.length !== 0
  //         ) {
  //           const textualSubscriptions = await getSubscriptions("textual");
  //           setTextualSubscriptionPrices(
  //             textualSubscriptions.data.subscriptions
  //           );
  //           addSubscription(
  //             textualSubscriptions.data.subscriptions[0]._id,
  //             textualSubscriptions.data.subscriptions[0].price,
  //             "textual",
  //             textualSubscriptions.data.subscriptions[0].name
  //           );
  //           setUserHaveImageSubscription(true);
  //         } else if (
  //           imageSubscription.length === 0 &&
  //           textualSubscription.length !== 0
  //         ) {
  //           const imageSubscriptions = await getSubscriptions("image");
  //           setimageSubscriptionPrices(imageSubscriptions.data.subscriptions);

  //           addSubscription(
  //             imageSubscriptions.data.subscriptions[0]._id,
  //             imageSubscriptions.data.subscriptions[0].price,
  //             "image",
  //             imageSubscriptions.data.subscriptions[0].name
  //           );
  //           setUserHaveTextualSubscription(true);
  //         }
  //       } catch (ex) {
  //         toast.error(ex.response.data.message);
  //       }
  //     }
  //   };

  //   getSubscriptionsApi();
  // }, [decodedToken]);

  // const [cart, setCart] = useState([
  //   {
  //     price: 250000,
  //     kind: "textual",
  //     _id: "10213",
  //     text: "1 ماه مقالات متنی",
  //   },
  //   { price: 30000, kind: "image", _id: "13243", text: "1 ماه مقالات تصویری" },
  // ]);

  //todo create useEffect to set starter subscriptions
  // useEffect(() => {
  //   const haveTextualSubscription = items.filter((i) => i.kind === "textual");
  //   if (
  //     textualSubscriptionPrices.length > 0 &&
  //     haveTextualSubscription.length === 0
  //   ) {
  //     addSubscription(
  //       textualSubscriptionPrices[0]._id,
  //       textualSubscriptionPrices[0].price,
  //       "textual",
  //       textualSubscriptionPrices[0].name
  //     );
  //   }
  //   const haveImageSubscription = items.filter((i) => i.kind === "image");
  //   if (
  //     imageSubscriptionPrices.length > 0 &&
  //     haveImageSubscription.length === 0
  //   ) {
  //     addSubscription(
  //       imageSubscriptionPrices[0]._id,
  //       imageSubscriptionPrices[0].price,
  //       "image",
  //       imageSubscriptionPrices[0].name
  //     );
  //   }
  // }, [
  //   textualSubscriptionPrices,
  //   imageSubscriptionPrices,
  //   addSubscription,
  //   items,
  // ]);

  useEffect(() => {
    const quarterlysApi = async () => {
      try {
        const { data } = await getQuarterlys("quarterly");
        setQuarterlys(data.quarterlys);
      } catch (ex) {
        console.log(ex.response.data.message);
      }
    };
    const booksApi = async () => {
      try {
        const { data } = await getBooks();
        const { data: userBooks } = await getMyBooks();
        let buyableBooks = data.books;
        for (const b of userBooks.myBooks) {
          buyableBooks = buyableBooks.filter((i) => i._id !== b._id);
        }
        setBooks(buyableBooks);
      } catch (ex) {
        console.log(ex);
        toast.error(ex.response.data.message);
      }
    };
    quarterlysApi();
    booksApi();
  }, []);

  const [totalPrice, setTotalPrice] = useState(0);

  const [paymentMethod, setPaymentMethod] = useState("cash");

  const [showQuarterlySelect, setShowQuarterlySelect] = useState(false);
  const [showBooksSelect, setShowBooksSelect] = useState(false);

  useEffect(() => {
    let newPrice = 0;
    // let newSubsPrice = 0;
    for (const item of items) {
      newPrice +=
        item.kind === "book" || item.kind === "quarterly"
          ? item.price
          : paymentMethod === "installment"
          ? (item.price * 35) / 100
          : item.price;
    }

    // for (const i of items) {
    //   newSubsPrice += i.kind === "textual" || i.kind === "image" ? i.price : 0;
    // }
    // setSubscriptionsPrice(newSubsPrice);
    setTotalPrice(newPrice);
  }, [items, paymentMethod]);

  // const handleAddSubscription = (e) => {
  //   if (+e.target.value === 0) {
  //     deleteSubscription(e.target.name);
  //   } else {
  //     const price =
  //       e.target.name === "textual"
  //         ? textualSubscriptionPrices.find(
  //             (item) => item._id === e.target.value
  //           ).price
  //         : imageSubscriptionPrices.find((item) => item._id === e.target.value)
  //             .price;
  //     const text =
  //       e.target.name === "textual"
  //         ? textualSubscriptionPrices.find(
  //             (item) => item._id === e.target.value
  //           ).name
  //         : imageSubscriptionPrices.find((item) => item._id === e.target.value)
  //             .name;
  //     addSubscription(e.target.value, price, e.target.name, text);
  //   }
  // };

  const handleAddToCard = ({ kind, id, price, text }) => {
    const result = addItem({ price, id, kind, text });
    if (result) {
      toast.success(
        `${
          kind === "book" ? "کتاب" : "فصلنامه"
        } ${text} با موفقیت به سبد خرید اضافه شد`
      );
    }
  };

  const closeSelectedQuarterly = (_id) => {
    deleteItem(_id);
  };
  const closeSelectedBook = (_id) => {
    deleteItem(_id);
  };

  const handlePayment = async (e) => {
    e.preventDefault();
    if (items.length === 0) {
      toast.error("سبد خرید شما خالی است");
    }
    // else if (
    //   subscriptionsPrice <= 300000 &&
    //   paymentMethod === "installment"
    // ) {
    //   toast.error("پرداخت قسطی فقط برای اشتراک بالای ۳۰۰ هزار تومان است");
    // }
    else {
      try {
        const { data } = await createAwaitingPayment({
          data: items,
          payKind: paymentMethod,
        });
        if (data.authority) {
          redirectToPaymentPage(data.authority);
        } else {
          toast.error("مشکلی در پرداخت پیش آمده");
        }
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          toast.error("لطفا اینترنت خود را بررسی کنید");
        }
        toast.error(error.response.data.message);
      }
    }
  };

  const redirectToPaymentPage = (authority) => {
    const paymentUrl = `https://www.zarinpal.com/pg/StartPay/${authority}`;

    window.location.href = paymentUrl;
  };

  if (!isLoggedIn) {
    return history.replace("/users/login");
  }

  return (
    <div className={Styles.cartContainer}>
      {showQuarterlySelect && (
        <div className={Styles.quarterlyItems}>
          {quarterlys.length > 0 ? (
            <>
              <div className={Styles.wrappedItems}>
                {quarterlys.map((item, index) => (
                  <QuarterCartForCart
                    index={index}
                    key={item._id}
                    handleAddToCard={handleAddToCard}
                    _id={item._id}
                    price={item.price}
                    name={item.title}
                    writer={item.writer}
                    image={item.frontCover}
                  />
                ))}
              </div>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setShowQuarterlySelect(false);
                }}
                className={Styles.close}
              >
                بستن
              </button>
            </>
          ) : (
            <>
              <h2 className={Styles.nullMessage}>فصلنامه ای موجود نیست</h2>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setShowQuarterlySelect(false);
                }}
                className={Styles.close}
              >
                بستن
              </button>
            </>
          )}
        </div>
      )}
      {showBooksSelect && (
        <div className={Styles.quarterlyItems}>
          {books.length > 0 ? (
            <>
              <div className={Styles.wrappedItems}>
                {books.map((item, index) => (
                  <BookCartForCart
                    index={index}
                    key={item._id}
                    handleAddToCard={handleAddToCard}
                    _id={item._id}
                    price={item.price}
                    name={item.title}
                    writer={item.writer}
                    image={item.frontCover}
                  />
                ))}
              </div>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setShowBooksSelect(false);
                }}
                className={Styles.close}
              >
                بستن
              </button>
            </>
          ) : (
            <>
              <h2 className={Styles.nullMessage}>کتابی موجود نیست</h2>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setShowBooksSelect(false);
                }}
                className={Styles.close}
              >
                بستن
              </button>
            </>
          )}
        </div>
      )}
      <div className={Styles.selectionContainer}>
        {/* <div className={Styles.container}>
          <img src={subscriptionImage} alt="" />
          <h2>اشتراک مقالات :</h2>
          {userHaveTextualSubscription && (
            <select>
              <option value="null">شما اشتراک مقالات متنی دارید</option>
            </select>
          )}
          {textualSubscriptionPrices.length > 0 && (
            <select
              onChange={handleAddSubscription}
              defaultValue={textualSubscriptionPrices[0]._id}
              name="textual"
              id="textualOptions"
            >
              <option value={0}>نیازی ندارم</option>
              {!decodedToken?.user.subscriptionStatus.have &&
                textualSubscriptionPrices.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.name} :{" "}
                    {convertNumbersToPersian(item.price.toLocaleString())}
                  </option>
                ))}
            </select>
          )}
          <div className={Styles.separator}></div>
          {userHaveImageSubscription && (
            <select>
              <option value="null">شما اشتراک مقالات تصویری دارید</option>
            </select>
          )}
          {imageSubscriptionPrices.length > 0 && (
            <select
              onChange={handleAddSubscription}
              defaultValue={imageSubscriptionPrices[0]._id}
              name="image"
              id="imageOptions"
            >
              <option value={0}>نیازی ندارم</option>
              {!decodedToken?.user.subscriptionStatus.have &&
                imageSubscriptionPrices?.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name} :{" "}
                    {convertNumbersToPersian(item.price.toLocaleString())}
                  </option>
                ))}
            </select>
          )}
        </div> */}
        <div className={Styles.container}>
          <img src={quarterlyImage} alt="" />
          <h2>فصلنامه :</h2>
          {items.map(
            (item) =>
              item.kind === "quarterly" && (
                <div key={item._id} className={Styles.quarterlyItem}>
                  <h4>
                    {item.text} :{" "}
                    {convertNumbersToPersian(item.price.toLocaleString())}
                  </h4>
                  <img
                    onClick={() => closeSelectedQuarterly(item.id)}
                    src={closeImage}
                    alt=""
                  />
                </div>
              )
          )}
          <h4
            onClick={() => {
              quarterlys.length === 0
                ? toast.error("در حال حاضر فصلنامه ای موجود نیست")
                : setShowQuarterlySelect(true);
            }}
          >
            انتخاب
          </h4>
        </div>
        <div className={Styles.container}>
          <img src={bookImage} alt="" />
          <h2>کتاب :</h2>
          {items.map(
            (item) =>
              item.kind === "book" && (
                <div key={item.id} className={Styles.quarterlyItem}>
                  <h4>
                    {item.text} :{" "}
                    {convertNumbersToPersian(item.price.toLocaleString())}
                  </h4>
                  <img
                    onClick={() => closeSelectedBook(item.id)}
                    src={closeImage}
                    alt=""
                  />
                </div>
              )
          )}
          <h4
            onClick={() => {
              books.length === 0
                ? toast.error("در حال حاضر کتابی موجود نیست")
                : setShowBooksSelect(true);
            }}
          >
            انتخاب
          </h4>
        </div>
      </div>
      <div className={Styles.centerSeparator}></div>
      <h2 className={Styles.bill}>صورتحساب</h2>
      <div className={Styles.billContainer}>
        <div
          className={`${Styles.right} ${
            items.length === 0 ? Styles.emptyCart : {}
          }`}
        >
          {items.length === 0 ? (
            <h2>سبد خرید خالی است</h2>
          ) : (
            items.map((item, index) => (
              <div key={index} className={Styles.billItems}>
                <h4>
                  {item.kind === "book"
                    ? "کتاب : "
                    : item.kind === "quarterly"
                    ? "فصلنامه : "
                    : "اشتراک : "}
                  {item.text}
                </h4>
                <h4>
                  {convertNumbersToPersian(item.price.toLocaleString())} تومان
                </h4>
              </div>
            ))
          )}
        </div>
        <div className={Styles.left}>
          <div className={Styles.finalPaymentText}>
            <h2>پرداخت نهایی</h2>
          </div>
          <div className={Styles.finalPaymentDetails}>
            {/* <div className={Styles.inputContainer}>
              <input
                onChange={(e) => setPaymentMethod(e.target.value)}
                id="cashpayment"
                type="radio"
                name="paymentType"
                value="cash"
                defaultChecked
              />
              <label htmlFor="cashpayment">پرداخت نقدی</label>
            </div> */}
            {/* <div className={Styles.inputContainer}>
              <input
                onChange={(e) => {
                  if (subscriptionsPrice > 300000) {
                    setPaymentMethod(e.target.value);
                  } else if (subscriptionsPrice <= 300000) {
                    toast.error(
                      "پرداخت قسطی فقط برای اشتراک های بالای سیصد هزار تومان است"
                    );
                  }
                }}
                id="installmentpayment"
                disabled={subscriptionsPrice <= 300000}
                type="radio"
                name="paymentType"
                value="installment"
              />
              <label htmlFor="installmentpayment">پرداخت قسطی</label>
              <Tippy
                placement="top-start"
                animation="scale-extreme"
                content="در خرید قسطی تنها اشتراک مقالات به صورت قسطی محاسبه خواهد شد و اقساط به صورت سه قسط پرداخت خواهد شد. درهنگام پرداخت ۳۵ درصد و ماه دوم ۳۵ درصد و ماه سوم ۳۰ درصد پرداخت خواهد شد.موعد پرداخت در همین سایت به شما یادآوری خواهد شد"
                className="newtippyreact"
              >
                <img src={questionImage} alt="" />
              </Tippy>
            </div> */}
            <h2 className={Styles.totalPrice}>
              مبلغ قابل پرداخت :{" "}
              {convertNumbersToPersian(totalPrice.toLocaleString())} تومان
            </h2>
            <button onClick={handlePayment} className={Styles.pay}>
              پرداخت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
